import { LocalClinicFormData } from 'models/forms';

export const emptyLocalCliicFormData = () => {
    return {
        name: '',
        organizationNumber: '',
        address: undefined,
        email: '',
        phone: '',
        site: '',
    } as LocalClinicFormData;
};
